import axios from "../lib/axios";
import {MASTER_DIVISION_FIND_MANY } from "../lib/endpoints/category";
import { SuppliesDivisionModel } from "../models/suppliesDivisionModel";



export const getAllMasterDivision=async ():Promise<SuppliesDivisionModel[]>=>{
  const res=await axios.post(MASTER_DIVISION_FIND_MANY);

  return res?.data;
}

export const getMasterDivision=async (mainGroupId:string):Promise<SuppliesDivisionModel[]>=>{
    const res=await axios.post(MASTER_DIVISION_FIND_MANY,{
        "filter": {
          "supplies_main_group_name_id": mainGroupId
        }
      });

    return res?.data;
}